export const daysOfTheWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
] as const;

export type DayOfTheWeek = (typeof daysOfTheWeek)[number];

const hourOptions = [
  "12",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
] as const;
const minuteOptions = ["00", "15", "30", "45"] as const;
const meridiemOptions = ["am", "pm"] as const;

type GetTimeOptions<
  T extends string[] = [],
  Meridiem extends 1[] = [],
  Hour extends 1[] = [],
  Minute extends 1[] = [],
> = Meridiem["length"] extends 2
  ? T
  : Hour["length"] extends 12
    ? GetTimeOptions<T, [...Meridiem, 1]>
    : Minute["length"] extends 4
      ? GetTimeOptions<T, Meridiem, [...Hour, 1]>
      : GetTimeOptions<
          [
            ...T,
            `${(typeof hourOptions)[Hour["length"]]}:${(typeof minuteOptions)[Minute["length"]]}${(typeof meridiemOptions)[Meridiem["length"]]}`,
          ],
          Meridiem,
          Hour,
          [...Minute, 1]
        >;

type AllTimeOptions = [...GetTimeOptions, "11:59pm"];

const getTimeOptions = () => {
  const timeOptions: string[] = [];

  for (const meridiem of meridiemOptions) {
    for (const hour of hourOptions) {
      for (const minute of minuteOptions) {
        timeOptions.push(`${hour}:${minute}${meridiem}`);
      }
    }
  }
  timeOptions.push("11:59pm");

  return timeOptions;
};

export const timeOptions = getTimeOptions();
export type TimeOption = AllTimeOptions[number];
